<template>
  <div>
    <PrepostEdit :id="id" :dialog="dialog.edit" v-on:close="close()" state="VIEW" />
    <el-table :data="tableData" stripe v-loading="loading" ref="tablePrepost" size="mini" style="width: 100%"
      :default-sort="{ prop: 'id', order: 'ascending' }">
      <el-table-column sortable prop="tag" label="Etiqueta">
        <template slot-scope="scope">
          <tag-link :tag="scope.row.tag" />
        </template>
      </el-table-column>
      <el-table-column sortable prop="senderName" label="Remetente"></el-table-column>
      <el-table-column sortable prop="destinyname" label="Destinatário"></el-table-column>
      <el-table-column sortable prop="weight" label="Peso"></el-table-column>
      <el-table-column sortable prop="service" label="Serviço"></el-table-column>
      <el-table-column sortable prop="createdAt" label="Data Criação"></el-table-column>
      <el-table-column sortable prop="postedAt" label="Data Postagem"></el-table-column>
      <el-table-column width="160" sortable prop="status" :label="$t('status')"></el-table-column>
      <el-table-column width="270" align="right">
        <template slot="header" slot-scope="scope">
          <span v-if="tableData.length">
            <el-button type="text" @click="pdf()"><i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;PDF</el-button>
            <el-button type="text" @click="csv()"><i class="fa fa-file-excel-o" aria-hidden="true"></i>&nbsp;CSV</el-button>
          </span>
        </template>
        <template slot-scope="scope">
          <el-button type="primary" size="small" title="Imprimir essa etiqueta" icon="el-icon-printer"
            @click="printsingle(scope.$index, scope.row)" circle></el-button>
          <el-button type="warning" size="small" title="Visualizar esse objeto" icon="el-icon-edit"
            @click="edit(scope.$index, scope.row)" circle></el-button>
          <el-button size="small" title="Comprovante de postagem" icon="el-icon-document"
            @click="proof(scope.$index, scope.row)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import TagLink from '../../views/dashboard/prepost/components/TagLink.vue';
import { PdvDashboardService } from "@/services/pdv/pdv.dashboard.services";
import { PrepostService } from "@/services/customers/prepost.services";
import PrepostEdit from "@/xpost/views/services/pre.post/PrePostEdit.vue";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "PdvCallListPrepost",
  props: ["customer", "startedAt", "finishedAt"],
  components: {
    TagLink,
    PrepostEdit
  },
  data() {
    return {
      loading: false,
      tableData: [],
      id: '',
      dialog: {
        edit: false,
      }
    };
  },
  methods: {
    edit(index, record) {
      const vm = this;
      vm.id = record.id;
      vm.dialog.edit = true;
    },
    close() {
      const vm = this;
      vm.dialog.edit = false;
    },
    printsingle(index, row) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.print([row.tag], { declared: true, warning: true, model: '1', type: '1' })
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${row.tag}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    proof(index, row) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.proof(row.tag)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${row.tag}-comprovante.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    pdf() {
      this.fetch({
        action: 'export',
        type: 'pdf'
      })
    },
    csv() {
      this.fetch({
        action: 'export',
        type: 'csv'
      })
    },
    fetch(options) {
      const vm = this;
      vm.loading = true;
      const s = moment(vm.startedAt);
      const f = moment(vm.finishedAt);
      if (!options) {
        options = {
          action: 'table',
          type: ''
        }
      }
      PdvDashboardService.post(
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.customer,
        options.action,
        options.type,
      )
        .then((response) => {
          if (options.action !== 'export') {
            vm.tableData = response;
            vm.$emit('update', 'post', vm.tableData.length)
          } else {
            var downloadLink = document.createElement("a");
            downloadLink.href = response;
            downloadLink.download = `atendimento.${options.type}`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          }
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => vm.loading = false);
    },
  },
};
</script>
